// autoChatConstants.js
'use strict';

export const USER_ID = '57a42a779f22bb6bcc434520';
export const CHAT_ID = 'auto-chat';
export const USERNAME_LOKALISE_KEY = 'autochat_title';
